import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import { get } from "lodash";

import "./election-floating-widget.m.css";

function ElectionFloatingWidget() {
  const [showWidgetButton, setShowWidgetButton] = useState(true);
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const floatingWidgetConfig = qtState?.data?.frontendConfig?.floatingWidget;

  useEffect(() => {
    if (location.pathname.split("/")[1] === floatingWidgetConfig?.avoidUrl) {
      setShowWidgetButton(false);
    }
  }, []);

  return (
    <>
      {showWidgetButton && floatingWidgetConfig?.enabled && (
        <div styleName="election-toggle-widget-wrapper" className="election-floating-widget">
          <div styleName="button-and-close-wrapper">
            <span
              styleName="close-widget-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowWidgetButton(false);
              }}
            >
              &times;
            </span>
            <Link
              styleName="flip-image-wrapper"
              href={`${floatingWidgetConfig?.landingUrl || ""}`}
            >
              <div
                styleName="flip"
                style={{
                  "--front-image": `url('${floatingWidgetConfig?.imageFront || ""}')`,
                  "--back-image": `url('${floatingWidgetConfig?.imageBack || ""}')`,
                }}
              />
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default ElectionFloatingWidget;
